import ErrorBoundary from 'components/atoms/error_boundary';
import OpenTutorial from 'components/atoms/open_tutorial';
import ByMeByAllFilter from 'components/molecules/by_me_by_all_filter';
import CalendarPage from 'components/molecules/calendar_page';
import FavoritedPage from 'components/molecules/favorited_page';
import FinishedPage from 'components/molecules/finished_page';
import ManagedPage from 'components/molecules/managed_page';
import ManagementMenu from 'components/molecules/management_menu';
import ProgressPage from 'components/molecules/progress_page';
import TasksPage from 'components/organisms/tasks_page';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ApplicationState } from 'store';
import { ManagementState, ManagementTypes } from 'store/modules/management_store/types';

const Management = () => {
  const dispatch = useDispatch();

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const handleFilterBy = () => {
    dispatch({ type: ManagementTypes.HANDLE_FILTER_BY });
  };

  useEffect(() => {
    dispatch({ type: ManagementTypes.UPDATE_STORE_FIELDS });
    document.title = 'Gerenciar Licitações - ConLicitação';
  }, []);

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 py-4">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center mb-3">
              <h4 className="mb-1 mr-3">Gerenciar Licitações</h4>
              <OpenTutorial type="modal" source="management" />
            </div>
          </div>
          <div className="col-md-12 mb-2 d-flex justify-content-between">
            {management.selected_feature !== 'progress' && (
              <div className="d-block mr-1">
                <ByMeByAllFilter
                  source="management"
                  byMe={management.filtered_by === 'contact_client'}
                  byAll={management.filtered_by === 'client'}
                  handle={handleFilterBy}
                />
              </div>
            )}
            <div className="d-flex align-items-end">
              <Link
                className="btn btn-secondary text-center  "
                to="/minhas_licitacoes/configuracoes"
              >
                Configurações
              </Link>
            </div>
          </div>
          <ManagementMenu />
          <ErrorBoundary key={management.selected_feature}>
            {management.selected_feature === 'calendar' && <CalendarPage />}
            {management.selected_feature === 'favorites' && <FavoritedPage />}
            {management.selected_feature === 'managed' && <ManagedPage />}
            {management.selected_feature === 'tasks' && <TasksPage />}
            {management.selected_feature === 'progress' && <ProgressPage />}
            {management.selected_feature === 'finished' && <FinishedPage />}
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default Management;
